export enum ActivitySummaryTabOptions {
  CategoryWholeClass = "'category-whole-class'",
  CategoryNeedAHelpingHand = "'category-need-a-helping-hand'",
  CategoryReadyForMore = "'category-ready-for-more'",
  CategoryTimeToPractice = "'category-time-to-practice'"
}
